import { put, call, takeLatest, all } from 'redux-saga/effects';
import i18n from 'i18next';
import { processRequest } from '../../../services/Api';
import { historyPush } from '../../../services/History';
import { manageQuizActionTypes } from './Constants';
import * as manageQuizActions from './Actions';
import * as notificationActions from '../../notification/Actions';
import * as errorHandlerActions from '../../errorHandler/Actions';
import * as sharedActions from '../../../pagesNext/shared/Actions';

export default function* () {
	yield all([
		yield takeLatest(
			manageQuizActionTypes.GET_QUIZ_AVAILABLE_SUBJECTS,
			handleAvailableSubjectsRequest,
		),
		yield takeLatest(
			manageQuizActionTypes.GET_QUIZ_AVAILABLE_TOPICS,
			handleAvailableTopicsRequest,
		),
		yield takeLatest(manageQuizActionTypes.MANAGE_QUIZ, handleManageQuizRequest),
	]);
}

export function* handleAvailableSubjectsRequest({ payload }) {
	try {
		const { source, params = {} } = payload || {};
		const requestPayload = { ...(source ? { source } : {}), ...params };

		const { data } = yield call(processRequest, 'subjects', 'GET', requestPayload);

		yield put(manageQuizActions.getSubjectsSuccess(data));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'notification'));
		yield put(manageQuizActions.getSubjectsError());
	}
}

export function* handleAvailableTopicsRequest({ payload }) {
	try {
		const { subjectId } = payload;
		const { data } = yield call(processRequest, `public/subjects/${subjectId}/topics`);
		yield put(manageQuizActions.getTopicsSuccess({ topics: data.results }));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'ignore'));
		yield put(manageQuizActions.getTopicsError());
	}
}

export function* handleManageQuizRequest(action) {
	try {
		const { formData, editId, callback } = action.payload;
		const callType = editId ? 'PATCH' : 'POST';

		const { data } = yield call(
			processRequest,
			`user_quizzes${editId ? `/${editId}` : ''}`,
			callType,
			{ user_quiz: formData },
		);

		yield put(manageQuizActions.manageQuizSuccess(data));
		yield put(
			notificationActions.createNotification(
				editId
					? i18n.t('modals.manage_quiz_modal.edit_notification')
					: i18n.t('modals.manage_quiz_modal.create_notification'),
			),
		);

		if (callback) {
			callback(data.user_quiz);
		} else {
			yield call(historyPush, `/edit-quiz/${data.user_quiz.id}`);
		}

		if (data.suggested_subjects)
			yield put(sharedActions.getUserSuggestedSubjectsSuccess(data.suggested_subjects));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'notification'));
		yield put(manageQuizActions.manageQuizError());
	}
}
